import { showFailureToast } from "@helpers";
import { enrollmentApi } from "@services/api";
import { call, put } from "redux-saga/effects";
import { checkEnrollmentAction, enrollActions } from "../slices";

function* enrollWorker({ payload }) {
  try {
    yield put(enrollActions.pending(payload));
    const response = yield call(enrollmentApi.enroll, payload.courseId);
    // TODO: handle callback | onSuccess
    yield put(enrollActions.success(response));
    yield put(checkEnrollmentAction(payload.courseId));
    if (payload.callback) {
      yield call(payload.callback);
    }
  } catch (error) {
    yield put(enrollActions.failure(error));
    // TODO: handle callback | onFailure
    yield call(showFailureToast, "Enroll was failed!");
  }
}

export { enrollWorker };
